import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueMaterialCost', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/details/change-costs/issue-material-cost/issue-material-cost.html'),
        controller: 'IssueMaterialCostController',
        controllerAs: 'IssueMaterialCostCtrl',
        bindings: {
            cost: '=',
            issue: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-costs/issue-material-cost/issue-material-cost.component.ts